import { render, staticRenderFns } from "./post-sales-questionnaire.vue?vue&type=template&id=181ced34&scoped=true"
import script from "./post-sales-questionnaire.vue?vue&type=script&lang=ts"
export * from "./post-sales-questionnaire.vue?vue&type=script&lang=ts"
import style0 from "./post-sales-questionnaire.vue?vue&type=style&index=0&id=181ced34&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181ced34",
  null
  
)

export default component.exports